import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { mapGetters, mapState } from 'vuex'
import { USER_MODULE_NAME } from '@/modules/User/store/types'
import { FLOW_MODULE_NAME } from '@/modules/Flow/store/types'
import { WARRANTY_MODULE_NAME, UPDATE_LOADER } from '@/store/types'
import { hasRecentlyReportedError, clearErrorFlag } from '@/utils/errorFlag'

/**
 * @module
 * @name Error
 */
export default {
  name: 'Error',
  mixins: [flowMixin],
  data() {
    return {
      prevRoute: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  computed: {
    ...mapGetters(USER_MODULE_NAME, {
      getUserId: 'userId'
    }),

    ...mapGetters(FLOW_MODULE_NAME, {
      getFlowError: 'flowError'
    }),

    ...mapState(WARRANTY_MODULE_NAME, {
      stateSinisterId: 'sinisterId'
    }),

    errorCause() {
      if (this.$route.query.cause) {
        return this.$route.query.cause
      }
      if (this.getFlowError && this.getFlowError.response) {
        return 'backend'
      }
      return 'technical'
    },

    isBackendError() {
      return this.errorCause === 'backend'
    },

    phoneContactNumber() {
      return '00 33 9 78 97 80 00'
    },

    phoneContactHref() {
      const cleanNumber = this.phoneContactNumber.replace(/[^\d+]/g, '')
      return `tel:${cleanNumber}`
    }
  },
  methods: {
    /**
     * @function
     * @name routeBack
     * @description Push router to go to last route.
     */
    routerBack: function() {
      this.$router.go(-2)
    }
  },
  mounted() {
    // Notify Vue App of the current active element in screen
    this.notifyAppOfChanges(this)
    this.$store.commit(UPDATE_LOADER, false)

    if (!hasRecentlyReportedError()) {
      // Original behavior if not previous error reported
      // This avoids duplicated reports if error comes from a redirect
      const routePath = this.prevRoute ? this.prevRoute.path : (this.$route.path || null)
      const routeName = this.prevRoute ? this.prevRoute.name : null
      if (this.getUserId && this.stateSinisterId) {
        this.sendSentryError('An error has occurred in the application', 'error', {}, this.stateSinisterId, null, this.getFlowError, this.getUserId, routePath, routeName)
      } else {
        this.sendSentryError('No user data encountered', 'warning', {}, this.stateSinisterId, null, this.getFlowError, null, routePath, routeName)
      }
    }

    localStorage.clear()
    clearErrorFlag()
  }
}
